/*
 * Maison des Nus — desktop header nav dropdown controller.
 * The top-level nav dropdowns (Shop, About) are native <details class="oi-nav-dropdown">.
 * Native <details> happily allow several open at once; OI shows only ONE at a time. This:
 *   - closes every OTHER open dropdown when one opens (accordion / one-at-a-time),
 *   - closes all on an outside click,
 *   - closes all on Escape.
 * Mobile/tablet (< 990px) uses the separate slide-in drawer, so this only governs desktop.
 */
(function () {
  function init() {
    var nav = document.querySelector('.oi-header__nav');
    if (!nav) return;

    var dropdowns = Array.prototype.slice.call(nav.querySelectorAll('details.oi-nav-dropdown'));
    if (!dropdowns.length) return;

    function closeAll(except) {
      dropdowns.forEach(function (d) {
        if (d !== except && d.open) d.removeAttribute('open');
      });
    }

    dropdowns.forEach(function (d) {
      // 'toggle' fires after the open state flips — when this one opens, shut the rest.
      d.addEventListener('toggle', function () {
        if (d.open) closeAll(d);
      });
    });

    // Outside click closes any open dropdown.
    document.addEventListener('click', function (e) {
      if (nav.contains(e.target)) return;
      closeAll(null);
    });

    // Escape closes any open dropdown and returns focus to its summary.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var openOne = dropdowns.filter(function (d) { return d.open; })[0];
      if (!openOne) return;
      openOne.removeAttribute('open');
      var summary = openOne.querySelector('summary');
      if (summary) summary.focus();
    });
  }

  // Script is deferred, so the DOM is parsed; run now, but guard just in case.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
